import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import {
  ComboService,
  DesignphotoService,
  SalesOrderService,
} from "../../../services/index";

@Component({
  selector: "addEditPurchaseOrder",
  templateUrl: "./verifySalesOrder.html",
})
export class verifySalesOrder {
  row: any;
  data: any;
  designdata: any = {};
  wodata: any = {
    shirtdno: "",
    party_code: "UNIT 1",
    party_name: "SKT CLOTHING CO",
    halfrate: 0,
    fullrate: 0,
    totalrate: 0,
  };
  qualityList: any;
  typeList = ["Order Form", "Open Order"];
  colorList: any;
  designnoList = [];
  codeList: any;
  widthList: any[];
  agentList = [];
  partyList = [];
  seasonList = [];
  shirttypeList = [];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  salesdata: any = {
    entry_type: "Pcs",
    rc_no: "",
    dead_stk: "No",
    wo_type: "Sales",
    stk_pcs: "",
    file_name: "",
    order_type: "",
  };

  designList = [
    {
      design_no: "",
      typeid: "",
      type: "",
      rangefrom: "",
      rangeto: "",
      color: "",
      f36: 0,
      f38: 0,
      f40: 0,
      f42: 0,
      f44: 0,
      f46: 0,
      fqty: 0,
      hqty: 0,
      h36: 0,
      h38: 0,
      h40: 0,
      h42: 0,
      h44: 0,
      h46: 0,
      totqty: 0,
      design_id: 0,
    },
  ];
  mode: string;
  saveEvent: any;
  // agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;

  @Input() set params(val: any[]) {
    if (_.isEmpty(val)) {
      let row: any = {};
      row.tabevent = new EventEmitter();
      let tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD SALES ORDER",
          title: "ADD SALES ORDER",
          tabParent: "SALES_PLAN",
          mode: "verify",
          data: row,
          name: "ADD SALES ORDER",
        },
      };
      this._params = tabObj;
      val = this._params;
      this.mode = tabObj.params.mode;
      this.saveEvent = row.tabevent;
      let designdata = Object.assign({}, tabObj.params["data"]);
      this.salesdata = designdata;
    } else {
      this._params = val;
      this.mode = val["mode"];
      this.saveEvent = val["data"].tabevent;
      let designdata = Object.assign({}, val["data"]);
      this.salesdata = designdata;
      if (this.mode == "Edit") {
        this.salesdata.entry_type = "Pcs";
        this.salesdata.rc_no = "";
        this.salesdata.dead_stk = "No";
        this.salesdata.wo_type = "Sales";
        this.salesdata.stk_pcs = "";
        this.salesdata.file_name = "";
        this.salesdata.so_date = this.datePipe.transform(
          this.salesdata.so_date,
          "yyyy-MM-dd"
        );
        this.loaddesignList(this.salesdata.so_id);
      }
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private salesservice: SalesOrderService,
    private comboservice: ComboService,
    private designservice: DesignphotoService
  ) {
    this.row = {
      design_no: "",
      type: "",
      typeid: "",
      rangefrom: "",
      rangeto: "",
      color: "",
      f36: 0,
      f38: 0,
      f40: 0,
      f42: 0,
      f44: 0,
      f46: 0,
      fqty: 0,
      hqty: 0,
      h36: 0,
      h38: 0,
      h40: 0,
      h42: 0,
      h44: 0,
      h46: 0,
      totqty: 0,
    };
  }
  ngOnInit() {
    this.tableScroll();
    if (this.mode == "Add") {
      this.salesdata.so_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
    }
  }

  tableScroll() {
    $(".workorderbody").height(window.innerHeight - 400);
    $(".workorderbody").width(window.innerWidth - 30);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#date").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      if (this.salesdata.order_type == "Open Order") {
        nextEl = "type-0";
      }
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }
  /*
        onGoToNextFld($event, fld, ind) {
            let nxtInd = ind,
             
                shade = this.designList[ind]['shade'],
                color = this.designList[ind]['color'],
                f36 = this.designList[ind].f36,
                f38 = this.designList[ind].f38,
                f40 = this.designList[ind].f40,
                f42 = this.designList[ind].f42,
                f44 = this.designList[ind].f44,
                h36 = this.designList[ind].h36,
                h38 = this.designList[ind].h38,
                h40 = this.designList[ind].h40,
                h42 = this.designList[ind].h42,
                h44 = this.designList[ind].h44,
                totqty = this.designList[ind]['totqty'];
    
            let nxtRow = $('#row-' + ind).next('tr'); 
            if (fld == "design_no"  && nxtRow.length == 0) {
                let len = this.designList.length;
                let design_no = this.designList[len-1]['design_no'];
              
                nxtInd= nxtInd + 1;
                $('#' + 'design_no' + '-' + nxtInd).focus();
                   
                if(design_no!='' && nxtInd==len){
                   
                   this.designList.push({
                            design_no: '',
                            color: '',
                            f36: '',
                            f38: '',
                            f40: '',
                            f42: '',
                            f44: '',
                            fqty: 0,
                            hqty: 0,
                            h36: '',
                            h38: '',
                            h40: '',
                            h42: '',
                            h44: '',
                            totqty: 0
                    });
             
                $('#'  + 'design_no' + '-' + nxtInd).focus();
                
    
                }else if(design_no=='' && nxtInd==len){
                   let a= nxtInd - 1;
                     $('#' + 'design_no' + '-' + a).focus();
                } 
               
            }
            else if (fld=="f36" || fld=="f38" || fld=="f40" || fld=="f42" || fld=="f44") {
                 $('#'  + fld + '-' + nxtInd).select();
            } else if(fld=="h36" || fld=="h38" || fld=="h40" || fld=="h42"){
                $('#'  + fld + '-' + nxtInd).select();
            }
            else if (fld == "item_name") {
                let nxtRowID = nxtRow[0].id;
                nxtInd = nxtRowID.split("-")[1];
            }else{
            
            setTimeout(() => {
                $('#'  + fld + '-' + nxtInd).focus();
            }, 100);
    
            }
           
        }
    */

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      shade = this.designList[ind]["shade"],
      color = this.designList[ind]["color"],
      f36 = this.designList[ind].f36,
      f38 = this.designList[ind].f38,
      f40 = this.designList[ind].f40,
      f42 = this.designList[ind].f42,
      f44 = this.designList[ind].f44,
      f46 = this.designList[ind].f46,
      h36 = this.designList[ind].h36,
      h38 = this.designList[ind].h38,
      h40 = this.designList[ind].h40,
      h42 = this.designList[ind].h42,
      h44 = this.designList[ind].h44,
      h46 = this.designList[ind].h46,
      totqty = this.designList[ind]["totqty"];

    let nxtRow = $("#row-" + ind).next("tr");
    // let data = this.isRowEmpty(ind);
    if (fld == "design_no" && nxtRow.length == 0) {
      let len = this.designList.length;
      let design_no = this.designList[len - 1].design_no;
      if (design_no != "") {
        for (let i = 0; i < this.designList.length; i++) {
          if (ind + 1 == this.designList.length) {
            let rowdetail = Object.assign({}, this.row);

            this.designList.push(rowdetail);

            nxtInd = this.designList.length - 1;
          }
        }
      } else if (this.salesdata.order_type == "Open Order") {
        for (let i = 0; i < this.designList.length; i++) {
          if (ind + 1 == this.designList.length) {
            let rowdetail = Object.assign({}, this.row);

            this.designList.push(rowdetail);

            nxtInd = this.designList.length - 1;
            fld = "type";
          }
        }
      }
    } else if (
      fld == "f36" ||
      fld == "f38" ||
      fld == "f40" ||
      fld == "f42" ||
      fld == "f44" ||
      fld == "f46"
    ) {
      $("#" + fld + "-" + nxtInd).select();
    } else if (
      fld == "h36" ||
      fld == "h38" ||
      fld == "h40" ||
      fld == "h42" ||
      fld == "h44" ||
      fld == "h46"
    ) {
      $("#" + fld + "-" + nxtInd).select();
    }
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }
  loaddesignList(id) {
    let params = {
      so_id: id,
      order_type: "Order Form",
      page: 1,
      start: 0,
      limit: 100,
    };
    this.salesservice.getSoEntryGridShirtSizeDet(params).then((res: any) => {
      this.designList = res;

      this.calcRate();
    });
  }

  calcTotal($event, ind) {
    let nan = function (no) {
      if (no == "" || no == null || no == undefined) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    };

    let item = this.designList[ind];
    // if(this.mode=='Add'){
    /*  item.f36!=""?parseInt(item.f36):0;
          item.f38!=""?parseInt(item.f38):0;
          item.f40!=""?parseInt(item.f40):0;
          item.f42!=""?parseInt(item.f42):0;
          item.f44!=""?parseInt(item.f44):0;
          item.h36!=""?parseInt(item.h36):0;
          item.h38!=""?parseInt(item.h38):0;
          item.h40!=""?parseInt(item.h40):0;
          item.h42!=""?parseInt(item.h42):0;
          item.h44!=""?parseInt(item.h44):0;*/
    let fqty =
      nan(item.f36) +
      nan(item.f38) +
      nan(item.f40) +
      nan(item.f42) +
      nan(item.f44) +
      nan(item.f46);
    let hqty =
      nan(item.h36) +
      nan(item.h38) +
      nan(item.h40) +
      nan(item.h42) +
      nan(item.h44) +
      nan(item.h46);
    this.designList[ind].fqty = parseFloat("" + fqty);
    this.designList[ind].hqty = parseFloat("" + hqty);
    this.designList[ind].totqty = parseFloat(
      "" +
        (item.f36 +
          item.f38 +
          item.f40 +
          item.f42 +
          item.f44 +
          item.f46 +
          item.h36 +
          item.h38 +
          item.h40 +
          item.h42 +
          item.h44 +
          item.h46)
    );
    this.calcRate();
    /* }else{
 
             let f36 = parseInt(item.f36);
             let f38 : number = parseFloat(item.f38);
             let f40 : number = parseFloat(item.f40);
             let f42 : number = parseFloat(item.f42);
             let f44 : number = parseFloat(item.f44);
             let h36 : number = parseFloat(item.h36);
             let h38 : number = parseFloat(item.h38);
             let h40 : number = parseFloat(item.h40);
             let h42 : number = parseFloat(item.h42);
             let h44 : number = parseFloat(item.h44);
 
             let fqty =  f36+ f38+ f40 + f42 + f44;
             let hqty =  h36+ h38+ h40 +h42 + h44;
             this.designList[ind].fqty =fqty;
             this.designList[ind].hqty = hqty;
             this.designList[ind].totqty =  f36+ f38+ f40 + f42 + f44;
             this.calcRate();
         
         }
 */
  }

  calcRate() {
    let item = this.designList;

    let fullrate = 0,
      halfrate = 0,
      totalrate = 0;
    for (let i = 0; i < item.length; i++) {
      fullrate += item[i].fqty;
      halfrate += item[i].hqty;
      if (isNaN(fullrate)) {
        halfrate = 0;
      }
      if (isNaN(halfrate)) {
        halfrate = 0;
      }
      totalrate = fullrate + halfrate;
    }

    this.wodata.fullrate = fullrate;
    this.wodata.halfrate = halfrate;
    this.wodata.totalrate = totalrate;
  }

  isRowEmpty(ind) {
    let data = this.data.designList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  deleteRow(ind) {
    this.designList.splice(ind, 1);
  }

  onDeleteRow($event, fld, ind) {
    //     onDeleteRow(ind) {
    //  $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.designList.length > 1) {
          that.designList.splice(ind, 1);
          that.calcRate();
          if ($("#" + fld + "-" + (ind - 1)).length > 0) {
            $("#" + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
            $("#" + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) {}
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getOrderData(so_no) {
    let params = {
      so_no: so_no,
    };
    this.salesservice.getOrderData(params).then((res: any) => {
      //this.partyList = res;
      this.salesdata = res.data;
      this.salesdata.so_no = so_no;
      this.designList = res.list;
      for (var i = 0; i < res.list.length; i++) {
        this.calcTotal(i, i);
      }
    });
    this.salesdata.so_no = so_no;
  }

  onSelectdesign(desno, ind) {
    if (desno == "") {
      this.colorList = [];
    } else {
      let no = _.filter(this.designnoList, { design_no: desno });
      let id = no[0]["des_id"];
      let params = {
        des_id: id,
      };

      this.designservice.getDesignColorList(params).then((res: any) => {
        this.colorList = res;
      });
    }
  }
  onSelectType($event, ind) {
    this.designList[ind]["typeid"] = $event.item.id;
  }

  getDesignNoList() {
    let params = {};
    this.comboservice.getDesignCombo(params).then((res: any) => {
      this.designnoList = res;
    });
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.partyList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { genLedid: id });
      return fitem["name"];
    }
    return "";
  }

  onSelectSeason($event) {
    this.salesdata.season_year = $event.season_year;
  }

  onSelectParty($event) {
    this.salesdata.party_id = $event.item.genLedid;
    this.salesdata.agent_id = $event.item.agent_id;
    this.onEnterKeyPressed("season", "", "");
  }
  onSelectColor(design, color, ind) {
    if (isNaN(color)) {
      color = color.toUpperCase();
    }
    this.colorList.forEach((element) => {
      if (color == element.dispName) {
        this.designList[ind]["dispName"] = element.design_no;
        this.designList[ind]["des_id"] = element.des_id;
        this.designList[ind]["design_id"] = element.design_id;
      }
    });
  }

  onSelectItem($event, design, ind) {
    let design_no = _.filter(this.data.designList, {
      design_no: design.design_no,
      shade: design.shade,
    });

    if (design_no.length == 1) {
      this.onGoToNextFld($event, "quality", ind);
    } else {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "ALREADY EXISTS",
        body: "Design with this shade Already Exists",
      });
      design.design_no = "";
      design.shade = "";
    }
  }

  oncheckemptyrow() {
    let design = this.designList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].color) {
        desList.push(design[i]);
      }
      if (this.salesdata.order_type == "Open Order") {
        if (design[i].type) {
          desList.push(design[i]);
        }
      }
    }
    this.designList = desList;
    this.onSaveOrder();
  }

  onSaveOrder(): void {
    if (
      this.salesdata.party_name == undefined ||
      this.salesdata.season_name == undefined ||
      this.salesdata.order_type == undefined
    ) {
      swal("Make sure that all the details are entered!");
    } else {
      this.salesdata.entry_type = "Pcs";
      this.salesdata.rc_no = "";
      this.salesdata.dead_stk = "No";
      this.salesdata.wo_type = "Sales";
      this.salesdata.stk_pcs = "";
      this.salesdata.file_name = "";
      this.salesdata.book_no = JSON.stringify(this.salesdata.book_no);
      this.salesdata.book_nos = (this.salesdata.book_no || "").split(",");
      this.salesdata.book_no = parseInt(this.salesdata.book_no || "");
      this.salesdata.order_by = this.salesdata.order_by || "";
      this.salesdata.remarks = this.salesdata.remarks || "";
      let params: any = Object.assign({}, this.salesdata);
      params["tabevent"] = undefined;
      params["mode"] = this.mode;
      params["soGrid"] = JSON.stringify(this.designList);
      params["so_date"] = this.datePipe.transform(
        params["so_date"],
        "yyyy-MM-dd"
      );
      let that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to save this Order?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.salesservice
          .adduptSalesOrder(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/salesOrder/verifySalesOrder.ts